import { useState } from 'react'
import { useNavigate, Link, useLocation } from 'react-router-dom'
import { supabase } from '../supabaseClient'

export default function LoginPage() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()
  const from = location.state?.from?.pathname || '/admin/dashboard'

  const handleLogin = async (e) => {
    e.preventDefault()
    setError('')
    setLoading(true)
    const { error } = await supabase.auth.signInWithPassword({ email, password })
    setLoading(false)
    if (error) return setError(error.message)
    navigate(from, { replace: true })
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0d1f12] px-4">
      <div className="w-full max-w-sm rounded-2xl border border-orken-border bg-orken-bg-card p-8 shadow-lg">
        <div className="mb-6 text-center">
          <h1 className="text-2xl font-extrabold font-display text-white">Orken</h1>
          <p className="mt-1 text-sm text-orken-dim">Painel administrativo</p>
        </div>
        <form onSubmit={handleLogin} className="space-y-4">
          <div>
            <label className="block text-xs font-semibold text-orken-dim mb-1">E-mail</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full rounded-lg border border-orken-border bg-orken-bg-2 px-3 py-2.5 text-sm text-white placeholder-orken-muted focus:border-orken-accent focus:outline-none"
              placeholder="seu@email.com"
            />
          </div>
          <div>
            <label className="block text-xs font-semibold text-orken-dim mb-1">Senha</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full rounded-lg border border-orken-border bg-orken-bg-2 px-3 py-2.5 text-sm text-white placeholder-orken-muted focus:border-orken-accent focus:outline-none"
              placeholder="••••••••"
            />
          </div>
          {error && <p className="text-xs text-red-400">{error}</p>}
          <button
            type="submit"
            disabled={loading}
            className="w-full rounded-lg bg-orken-accent px-4 py-2.5 text-sm font-bold text-[#0d1f12] hover:bg-orken-accent-2 transition-colors disabled:opacity-50"
          >
            {loading ? 'Entrando…' : 'Entrar'}
          </button>
        </form>
        <p className="mt-4 text-center text-xs text-orken-muted">
          <Link to="/" className="text-orken-accent hover:underline">← Voltar ao site</Link>
        </p>
      </div>
    </div>
  )
}
